module.exports = __webpack_public_path__ + "static/media/ad-banner-accessories.24dfe785.jpg";